export { theme } from 'stile-shared/src/styles/2020/theme';
